
import VueSlickCarousel from 'vue-slick-carousel';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingQdapMallFnMixins from '~/mixins/eventTrackingQdapMallFnMixins.js';
export default {
  name: 'QdapHomeBlogSection',

  components: { VueSlickCarousel },

  mixins: [eventTrackingMixins, eventTrackingQdapMallFnMixins],

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
  },

  data() {
    return {
      isActive: true,
      activeBlogCategory: '',
      settings: {
        "dots": true,
        "arrows": true,
        "focusOnSelect": true,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 4,
        "slidesToScroll": 1,
        "touchThreshold": 5,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 1,
              "infinite": true,
              "dots": true,
              "arrows": true
            }
          },
          {
            "breakpoint": 760,
            "settings": {
              "slidesToShow": 2,
              "slidesToScroll": 1,
              "dots": true,
              "arrows": false
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1,
              "dots": true,
              "arrows": false
            }
          }
        ]
      }
    }
  },
  
  computed: {
    // activeBlogItems() {
    //   if(this.data) {
    //     const filtered = this.data
    //     return filtered
    //   }
    //   return null
    // }
  },

  mounted() {
  },

  methods: {
    setActiveBlogCategory(category) {
      this.activeBlogCategory = category
    },

    async handleClickBlogItem(blogSlug) {
      await this.handleEventTracking_qdapMallItemFromBlogSection(blogSlug);
      this.$router.push({
          path: `${this.localePath('/blog/'+ blogSlug)}`,
      })

    }
  },
}
